import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import {
    FormGroup,
    // DropdownButton,
    // MenuItem,
    ControlLabel,
    OverlayTrigger,
    FormControl
} from 'react-bootstrap';
import AdditionalInfoComponentC from './AdditionalInfoComponent';
import isDefined from '../utils/isDefined';
import { isEmpty } from 'lodash';

export class DropDownContainer extends React.Component {
    constructor(props) {
        super(props);

        const name = this.props.data.name;
        this.state = {
            disabled:
                this.props.initialParams[name] && this.props.initialParams[name].disabled
                    ? this.props.initialParams[name].disabled
                    : false,
            validationMessage: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeEvent = this.handleChangeEvent.bind(this);
        this.getValidationState = this.getValidationState.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps && !isEmpty(nextProps.addressValues)) {
            const name = nextProps.data.name;
            const initialValue = nextProps.addressValues[name];
            if (initialValue || initialValue === '') {
                this.setState({
                    value: isDefined(initialValue) ? initialValue : ''
                })
            }
        }
        if (nextProps.hidden === true) {
            this.setState({
                value: ''
            })
        }
        /**
         * Update "disabled" state data if the disableOtherField changes, otherwise
         * use default "disabled" value that is set during initialization of this component.
         */
        if (!this.props.isUnderwriter && nextProps.disableOtherField !== undefined
        && nextProps.disableOtherField !== this.props.disableOtherField) {
            this.setState({disabled: nextProps.disableOtherField})
        }
    }

    getValidationState() {
        // this bit of code acts as a circuit breaker
        // We want get validation to trigger
        // a validation function and when results are back we need to call it again
        // But this breaks the loops
        if (this.state.isValid) {
            const isValid = this.state.isValid;
            this.state.isValid = null;
            return isValid;
        }

        // only trigger validation if the value changes
        if (
            this.state.value !== '' &&
            this.props.data.attributes &&
            this.props.data.attributes.validationFunc &&
            this.props.validation[this.props.data.attributes.validationFunc]
        ) {
            this.props.validation[this.props.data.attributes.validationFunc](
                this.props.data.name,
                this.state.value
            ).then(result => {
                this.setState({
                    isValid: result ? 'success' : 'error',
                    validationMessage: result.status ? '' : result.message
                });
            });
        }

        if (this.state.isValid !== null) {
            return this.state.isValid;
        }

        if (this.props.data.attributes && this.props.data.attributes.validationRegEx) {
            const regex = new RegExp(unescape(this.props.data.attributes.validationRegEx));
            return regex.test(this.state.value) ? 'success' : 'error';
        }
    }

    componentWillMount() {
        if (this.props.initialValues[this.props.data.name]) {
            this.handleChange(this.props.initialValues[this.props.data.name]);
        } else {
            this.handleChange('');
            this.setState({
                value: this.props.data.attributes.options
                    ? this.props.data.attributes.options[0].value
                    : ''
            });
        }
    }

    async handleChange(value) {
        if (this.props.data.containRelationForms) {
            await this.props.handleRelationChange(value, this.props.data.containRelationForms, this.props.data);
        }
        if (this.props.data.affectOtherField) {
            if (value === 'Remodel/Renovation') {
                await this.props.handleOtherFieldChange(value, this.props.data.name, '');
            } else {
                await this.props.handleOtherFieldChange(value, this.props.data.name, this.props.data.affectOtherField);
            }
        }
        const option = this.props.data.attributes.options.filter(option2 => {
            return String(option2.value) == String(value);
        })[0];

        if (option && option.supplementalquestionIds && option.supplementalquestionIds.length > 0) {
            this.props.handleSupplementTrigger(option.supplementalquestionIds);
        } else {
            this.props.handleSupplementTrigger([]);
        }

        // Change dropdown title on select
        this.setState({
            value: !!option ? option.value :''
        });

        this.props.handleFormChange();
        if (this.props.addressValues) {
            let updatedValue = {};
            updatedValue[this.props.data.name] = value;
            const addressValues = Object.assign({}, this.props.addressValues, updatedValue);
            this.props.handleAddressChange(addressValues);
        }
    }

    handleChangeEvent(e) {
        this.handleChange(e.currentTarget.value);
    }

    render() {
        const authState = !!this.props.data.attributes.authState ? this.props.data.attributes.authState : true;
        this.options = this.props.data.attributes.options
            ? this.props.data.attributes.options.map((data, i) => {
                  let t =
                      i === 0 && !this.props.data.required ? data.text + ' (optional)' : data.text;
                      if (data.optionId ==1 || authState === true) {
                        if (data.optionId === '1' && data.value === 'noExcess') {
                            return (
                              <option value={data.value} key={data.optionId} hidden={false}>
                              {t}
                              </option>
                            )
                        }
                        if (data.optionId === '1') {
                            return (
                              <option value={data.value} key={data.optionId} hidden={true}>
                              {t}
                              </option>
                            )
                        }
                        else {
                            if (this.props.disableOtherField && !this.props.isUnderwriter) {
                                return
                            } else {
                                return (
                                <option value={data.value} key={data.optionId}>
                                    {t}
                                </option>
                                );
                            }
                        }
                     } else if (authState.indexOf(data.value)>=0) {
                      return (
                      <option value={data.value} key={data.optionId}>
                          {t}
                      </option>
                        );
                      }
              })
            : [];

        if (!this.props.data.text && !this.props.data.placeholder) {
            let data = this.props.data;
            if (data.attributes && data.attributes.options && data.attributes.options.length > 0) {
                this.props.data.placeholder = data.attributes.options[0].text;
            }
        }
        const cssChange = (this.props.data.name.endsWith('Relationship') ||
        this.props.data.name.endsWith('Role')) && this.state.value === 'Other'? true : false;

        return (
            <FormGroup
                className={classNames('with-extra-padding', { moveLeft: cssChange})}
                validationState={this.getValidationState()}
                controlId={this.props.data.name}
            >
                {!this.props.data.text && (
                    <label className={classNames({
                                mandatoryField: this.props.data.required,
                                requiredLabel: (!this.state.value && this.props.requiredLabel)
                            }, 'placeholder'
                    )}>
                        {this.props.data.placeholder || this.props.data.text}
                    </label>
                )}
                {this.props.data.name==='excessLimitAmount' && this.props.disableOtherField && !this.props.isUnderwriter &&(
                   <span>
                        <label className={classNames('helper-red-limit')}>Due to capacity issues, if the GC is insured with Argo, Colony or Peleus, we are unable to offer excess coverage. </label>
                      <br />
                   </span>
                )}
                {this.props.data.text && <ControlLabel className={classNames({mandatoryField: this.props.data.required, requiredLabel: (!this.state.value && this.props.requiredLabel) })}>{this.props.data.text}</ControlLabel>}

                <div className="select">
                    <FormControl
                        value={this.state.value}
                        className={classNames(
                            { filled: this.state.value },
                            { disabled: this.state.disabled }
                        )}
                        disabled={this.state.disabled || (this.props.isSameAddress && this.props.addressValues && this.props.data.questionId== "3c")}
                        onChange={this.handleChangeEvent}
                        componentClass="select"
                    >
                        {this.options}
                    </FormControl>
                </div>
                {this.props.data.helper && <div className="helper">{this.props.data.helper}</div>}

                <AdditionalInfoComponentC
                    additionalInfo1Color={this.props.data.additionalInfo1Color}
                    additionalInfo1={this.props.data.additionalInfo1}
                    additionalInfo2={this.props.data.additionalInfo2}
                    additionalInfoIcon={this.props.data.additionalInfoIcon}
                />
            </FormGroup>
        );
    }
}

DropDownContainer.propTypes = {
    data: PropTypes.object,
    handleFormChange: PropTypes.func,
    initialValues: PropTypes.object,
    initialParams: PropTypes.object,
    handleSupplementTrigger: PropTypes.func
};
export default DropDownContainer;
